export default __webpack_public_path__ + "static/media/code.300882ba.png";